/**
 * Created by Karol Kluska on 12.06.17.
 */

angular
  .module('app')
  .component('rateplanAvailabilityNavigation', {
    controller: Navigation,
    bindings: {
      from: '<',
      to: '<',
      onChange: '&'
    },
    templateUrl: 'app/shared/rateplanAvailability/navigation/Navigation.html'
  });

function Navigation($translate) {
  var $this = this;
  $this.$translate = $translate;
}

Navigation.prototype = {
  $onInit: function () {
    this.monthsLength = this.to.diff(this.from, 'months') + 1;
  },

  nextMonth: function () {
    var from = moment(this.from).add(this.monthsLength, 'months');
    var to = moment(this.to).add(this.monthsLength, 'months');
    this.handleChange(from, to);
  },

  prevMonth: function () {
    var from = moment(this.from).subtract(this.monthsLength, 'months');
    var to = moment(this.to).subtract(this.monthsLength, 'months');
    this.handleChange(from, to);
  },

  handleChange: function (from, to) {
    this.onChange({from: from, to: to});
  },

  getYear: function (date) {
    return moment(date).year();
  },

  getMonthName: function (date) {
    var monthIndex = moment(date).month();
    var monthList = [
      this.$translate.instant('months.JANUARY'),
      this.$translate.instant('months.FEBRUARY'),
      this.$translate.instant('months.MARCH'),
      this.$translate.instant('months.APRIL'),
      this.$translate.instant('months.MAY'),
      this.$translate.instant('months.JUNE'),
      this.$translate.instant('months.JULY'),
      this.$translate.instant('months.AUGUST'),
      this.$translate.instant('months.SEPTEMBER'),
      this.$translate.instant('months.OCTOBER'),
      this.$translate.instant('months.NOVEMBER'),
      this.$translate.instant('months.DECEMBER')
    ];
    return monthList[monthIndex];
  }
};
